import { Center, Table, Text } from '@mantine/core'
import { memo } from 'react'
import { FormattedMessage } from 'react-intl'
import { DeviceLog } from '@/types/device'
import { DeploymentAppLogsRow } from './DeploymentAppLogsRow'

const COLUMN_COUNT = 4

type DeploymentAppLogsTableProps = {
  logs: DeviceLog[]
  searchTerm: string
  isEmpty?: boolean
  getCameraLabel?: (log: DeviceLog) => string
}

export const DeploymentAppLogsTable = memo(function DeploymentAppLogsTable({
  logs,
  searchTerm,
  isEmpty,
  getCameraLabel
}: DeploymentAppLogsTableProps) {
  return (
    <Table
      horizontalSpacing="xs"
      verticalSpacing="xs"
      highlightOnHoverColor="gray.1"
      styles={(theme) => ({
        th: {
          backgroundColor: theme.colors.gray[2],
          fontSize: theme.fontSizes.xs,
          fontWeight: 500
        }
      })}
      stickyHeader
      withTableBorder
      highlightOnHover
    >
      <Table.Thead>
        <Table.Tr>
          <Table.Th w={160}>
            <FormattedMessage id="deployments.details.tabs.appLogs.columns.timestamp" />
          </Table.Th>

          <Table.Th w={100}>
            <FormattedMessage id="deployments.details.tabs.appLogs.columns.level" />
          </Table.Th>

          {getCameraLabel && (
            <Table.Th w={140}>
              <FormattedMessage id="deployments.details.tabs.appLogs.columns.camera" />
            </Table.Th>
          )}

          <Table.Th w={120}>
            <FormattedMessage id="deployments.details.tabs.appLogs.columns.category" />
          </Table.Th>

          <Table.Th>
            <FormattedMessage id="deployments.details.tabs.appLogs.columns.message" />
          </Table.Th>
        </Table.Tr>
      </Table.Thead>

      <Table.Tbody>
        {isEmpty ? (
          <Table.Tr>
            <Table.Td colSpan={COLUMN_COUNT + (getCameraLabel ? 1 : 0)}>
              <Center mih={200}>
                <Text c="dimmed" size="sm">
                  <FormattedMessage id="deployments.details.tabs.appLogs.empty" />
                </Text>
              </Center>
            </Table.Td>
          </Table.Tr>
        ) : (
          logs.map((log) => (
            <DeploymentAppLogsRow
              key={log.id}
              log={log}
              searchTerm={searchTerm}
              cameraLabel={getCameraLabel?.(log)}
            />
          ))
        )}
      </Table.Tbody>
    </Table>
  )
})
